import { render, staticRenderFns } from "./armor.vue?vue&type=template&id=436e22fa&scoped=true&"
import script from "./armor.vue?vue&type=script&lang=js&"
export * from "./armor.vue?vue&type=script&lang=js&"
import style0 from "./armor.vue?vue&type=style&index=0&id=436e22fa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "436e22fa",
  null
  
)

export default component.exports